const column = [
  {
    title: "Index",
    scopedSlots: { customRender: "stt" },
    width: 100,
    align: "center",
  },
  {
    title: "Code",
    key: "code",
    dataIndex: "code",
  },
  {
    title: "Title",
    key: "title",
    dataIndex: "title",
    scopedSlots: { customRender: "namtitlee" },
    sorter: (positionA, positionB) => {
      var codeA = positionA.title.toUpperCase();
      var codeB = positionB.title.toUpperCase();
      return codeA.localeCompare(codeB);
    },
  },

  {
    title: "Created At",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Updated At",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 15,
  },
];

export { column };
